export default "__VITE_ASSET__WT3EX7UF__"